import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { Typography } from "@material-ui/core";

export default props => {
    return (
        <Autocomplete
            data-testid="client-selector"
            noOptionsText="Ingen klienter fundet"
            id="existing-client"
            style={{ width: "100%" }}
            disableClearable={true}
            options={props.clients.sort(
                (a, b) =>
                    -(b.nameFirst.trim() + " " + b.nameLast.trim()).localeCompare(
                        a.nameFirst.trim() + " " + a.nameLast.trim()
                    )
            )}
            getOptionLabel={client =>
                "(" +
                client.CPR6Digit +
                "-" +
                client.CPRLast4Digit +
                ")" +
                " " +
                client.nameFirst +
                " " +
                client.nameLast
            }
            renderOption={client => (
                <>
                    {
                        <div style={{ width: "750px", display: "flex" }}>
                            <div style={{ width: "250px" }}>{client.nameFirst + " " + client.nameLast}</div>
                            <div style={{ width: "250px" }}>
                                {client.CPR6Digit && client.CPR6Digit.replace("-", "")}
                                {client.CPRLast4Digit && client.CPRLast4Digit !== "" ? "-" : ""}
                                {client.CPRLast4Digit}
                            </div>
                            <div style={{ width: "250px" }}>{client.phonePrivate}</div>
                        </div>
                    }
                </>
            )}
            groupBy={option => option.group}
            renderGroup={g => (
                <>
                    {
                        <div style={{ width: "750px", display: "flex", fontWeight: "bold" }}>
                            <div style={{ width: "250px", padding: "0px 15px" }}>Navn</div>
                            <div style={{ width: "250px" }}>Fødselsdag</div>
                            <div style={{ width: "250px" }}>Telefonnummer</div>
                        </div>
                    }
                    {g.children.map(client => client)}
                </>
            )}
            onChange={(event, client) => {
                if (client === null) return;

                props.changeValue(client);
            }}
            onInputChange={event => {
                if (props.changeText) {
                    props.changeText(event);
                }
            }}
            renderInput={params => (
                <>
                    <TextField
                        {...params}
                        inputProps={{
                            ...params.inputProps,
                            name: Math.random(),
                            autoComplete: "new-password"
                        }}
                        label="Søg efter Navn, Fødselsdato, eller telefonnummer"
                        variant="outlined"
                    />
                    {props.isHideDesciption === true ? (
                        <></>
                    ) : (
                        <Typography color="textSecondary">Indsæt dit fulde CPR-nummer.</Typography>
                    )}
                </>
            )}
            filterOptions={createFilterOptions({
                //matchFrom: "start",
                //stringify: client => client.nameFirst + " " + client.nameLast
                stringify: client =>
                    client.nameFirst +
                    " " +
                    client.nameLast +
                    " " +
                    client.CPR +
                    client.CPR6Digit +
                    "-" +
                    client.CPRLast4Digit +
                    " " +
                    client.phonePrivate
            })}
        />
    );
};
